module.exports = __webpack_public_path__ + "img/marker8.eae6278c.webp";